import { Products } from 'types';
import creditScoreBad from 'img/vanskilaskra-ekki-ok.svg';
import creditScoreOk from 'img/vanskilaskra-ok.svg';

export function CreditCheckButtonText(products: Products, translate: Function) {
	if (!products.externalCreditCheck) {
		return translate('credit_info_lookup', 'products');
	}

	if (products.isElidgableForDerivatives) {
		return (
			<>
				{translate('credit_score_good', 'products')}
				<img src={creditScoreOk} alt="" className="ml-2" />
			</>
		);
	}

	return (
		<>
			{translate('credit_score_bad', 'products')}
			<img src={creditScoreBad} alt="" className="ml-2" />
		</>
	);
}
